import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { PlansQuery } from "services/graphql";
import { CHECKOUT_ESTIMATE_QUERY } from "graphql/queries";

export function useCoupon(
  selectedPlan: PlansQuery["plans"][0] | null,
  coupon = ""
) {
  const [hasCalledCheckoutEstimate, setHasCalledCheckoutEstimate] = useState(
    false
  );
  const [
    getCheckoutEstimate,
    { data: { checkoutEstimate = null } = {}, loading, error },
  ] = useLazyQuery(CHECKOUT_ESTIMATE_QUERY);

  useEffect(() => {
    if (!(coupon && selectedPlan)) {
      return;
    }

    getCheckoutEstimate({
      variables: {
        planInfo: {
          id: selectedPlan.provider.id,
          name: selectedPlan.provider.name,
        },
        couponId: coupon,
      },
      onCompleted: () => {
        setHasCalledCheckoutEstimate(true);
      },
    });
  }, [coupon, selectedPlan, getCheckoutEstimate]);

  return {
    couponEstimate: checkoutEstimate,
    couponSuccess: !!checkoutEstimate,
    hasCalledCheckoutEstimate,
    loadingCouponEstimate: loading,
    errorCouponEstimate: !!coupon && error,
  };
}
